import * as React from 'react';
import { MediaQueryContext } from './media-query.context';
import { useMediaQuery } from './media-query.hook';
export var MediaQueryProvider = function (props) {
    var isMediumOrLarger = useMediaQuery();
    var isLarger = useMediaQuery('large');
    var isMax = useMediaQuery('max');
    return (React.createElement(MediaQueryContext.Provider, { value: { isMediumOrLarger: isMediumOrLarger, isLarger: isLarger, isMax: isMax } }, props.children));
};
